module.exports = __webpack_public_path__ + "img/02_sub_uk.25fd3b45.svg";